export { default } from 'react-bootstrap/Collapse';
